import React from 'react';
import { Change } from 'types';
import { EditableGateway } from './modals';

/**
 * Why a gateway can't be added at a site where a site layout draft has been
 * published: its entries own its gateways from then on.
 */
export const GATEWAY_ADD_CLOSED_MESSAGE =
  "Gateways can't be added here any more: this site's entries are now " +
  'managed in Site Layout. Existing gateways can still be renamed or removed.';

export type GatewaysProps = {
  value?: EditableGateway[] | null;
  onChange?: (value: EditableGateway[]) => void;
  loading?: boolean;
  error?: React.ReactNode;
  /** Set once a site layout draft has been published at the site: gateways can be edited and removed, not added. */
  addClosed?: boolean;
};

export type GatewayChange = Change<EditableGateway>;
